<template>
  <div class="card">
    <div class="card__body">
      <header class="card__header">
        <h3 class="card__number">
          {{ flat[flatProperties['id']].toUpperCase() }}
        </h3>
      </header>

      <router-link :to="flatURL" class="card__image">
        <img
          v-if="planURL"
          :src="planURL"
          alt
          @error="
            () => {
              planError = true;
            }
          "
        />
        <p class="card__noimg" v-else>{{ $t('singleFlat.noPrev') }}</p>
      </router-link>

      <div class="card__info">
        <div class="card__data">
          <p class="card__label">{{ $t('singleFlat.area') }}:</p>
          <p class="card__value">
            {{ flat[flatProperties['area']] }}m<sup>2</sup>
          </p>
        </div>
        <div class="card__data">
          <p class="card__label">{{ $t('singleFlat.floor') }}:</p>
          <p class="card__value" v-if="flat[flatProperties['floor']] == 0">
            {{ $t('singleFlat.groundFloor').toLowerCase() }}
          </p>
          <p class="card__value" v-else>
            {{ flat[flatProperties['floor']] }}
            {{ $t('singleFlat.floor').toLowerCase() }}
          </p>
        </div>
        <div class="card__data">
          <p class="card__label">{{ $t('singleFlat.rooms') }}:</p>
          <p class="card__value">{{ flat[flatProperties['rooms']] }}</p>
        </div>
        <div class="card__status" :class="status">
          {{ getStatus(flat[flatProperties['status']]) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'flat-card',
  props: ['flat'],
  data() {
    return {
      planError: false,
    };
  },
  methods: {
    ...mapMutations({
      addToFavourites: 'ADD_TO_FAVOURITES',
      deleteFromFavourites: 'DELETE_FROM_FAVOURITES',
    }),
    toggleFavourites() {
      if (this.isFavourite) {
        this.deleteFromFavourites(this.flat);
        window.top.postMessage(
          `REMOVE_FAVOURITE/${this.flat[this.flatProperties['id']]}`,
          '*'
        );
      } else {
        this.addToFavourites(this.flat);
        window.top.postMessage(
          `ADD_FAVOURITE/${this.flat[this.flatProperties['id']]}`,
          '*'
        );
      }
    },
  },
  computed: {
    ...mapState({ flatProperties: state => state.browser.flatProperties }),
    ...mapGetters({
      getPlan: 'GET_PLAN',
      investmentURL: 'GET_INVESTMENT_URL',
      getStatus: 'GET_STATUS_NAME',
    }),
    status() {
      return this.$store.getters.GET_STATUS_CLASS(
        this.flat[this.flatProperties['status']]
      );
    },
    id() {
      return this.flat[this.flatProperties['id']].toUpperCase();
    },
    planURL() {
      if (this.planError) {
        return false;
      }

      if (!this.flat) return false;
      if (this.flat.investment)
        return this.getPlan(
          this.flat[this.flatProperties['realID']],
          this.flat.investment.assets
        );

      return this.getPlan(this.flat[this.flatProperties['realID']]);
    },
    flatURL() {
      return `/baltic-wave/flat/${this.flat[this.flatProperties['id']]}`;
    },
    isFavourite() {
      let favs = this.$store.getters.GET_FAVOURITES.map(
        fav => fav[this.flatProperties['id']]
      );
      return favs.includes(this.flat[this.flatProperties['id']]);
    },
  },
};
</script>

<style lang="scss">
sup {
  font-size: 10px;
  vertical-align: super;
}

.card {
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid $lightGray;
  border-radius: 24px;
  position: relative;
  padding: 16px;
  transition: 250ms;

  &:hover {
    border-color: $primaryColor;
    box-shadow: 0 0 50px rgba(#000000, 0.15);
  }
}

.card__body {
  width: 100%;
  height: 100%;
}

.card__header {
  // border-bottom: 1px solid $lightGray;
}

.card__number {
  text-align: right;
  font-weight: 500;
  font-size: 22px;
}

.card__status {
  font-weight: 400;
  font-size: 14px;
  &.available {
    color: $available;
  }

  &.reserved {
    color: $reserved;
  }

  &.sold {
    color: $sold;
  }
}

.card__noimg {
  font-size: 14px;
  text-align: center;
  @media screen and (max-width: $sm) {
    font-size: 10px;
  }
}

.card__image {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #000000;
  font-size: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid $lightGray;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.card__info {
  margin-top: 4px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 6px;
  align-items: flex-end;
}

.card__data {
  display: contents;
  align-items: center;
  margin: 4px auto;
}

.card__value {
  font-size: 12px;
  font-weight: 400;
}

.card__label {
  font-size: 12px;
  margin-right: 6px;
  color: #000;
}

.card__line {
  border: 0.5px solid rgba(#000000, 0.04);
}

.card__favourite {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  background: $primaryColor;
  padding: 12px 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transform: translate(-25%, -25%);
}
</style>
